import * as React from "react";
import styled from "@emotion/styled";

const FooterWrapper = styled('footer')`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff; /* #ffff から #ffffff (白) に修正しました */
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column; // スマホでは縦並びにする
  }
`;

const TextContentWrapper = styled.div`
  @media (max-width: 768px) {
    margin-left: 0; 
  }
`;

const Logo = styled('img')`
  margin-right: 20px;
  width: 200px;
  height: auto;
`;

const FooterContent = styled('div')`
  font-size: 13.5px; 
  word-break: break-all; // はみ出す単語を強制的に改行させる /* デスクトップ向けのフォントサイズ */
  text-align: center;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 9px; /* スマートフォン向けのフォントサイズに調整 */
  }
`;

const FooterLinks = styled('div')`
  display: flex;
  justify-content: center;
  gap: 15px;
  font-size: 13.5px; 
  word-break: break-all; // はみ出す単語を強制的に改行させる /* デスクトップ向けのフォントサイズ */

  a {
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    font-size: 9px; /* スマートフォン向けのフォントサイズに調整 */
    gap: 10px; /* リンク間の隙間も少し調整 */
    /* リンクが横並びで収まらない場合は縦積みにすることも検討 */
    /* flex-direction: column; */
    /* align-items: center; */
  }
`;

// Footer コンポーネントのJSX 
const Footer = () => (
  <FooterWrapper>
    <Logo src="/images/KKE_corporate_logo_color.jpg" alt="ADAP Logo" />
    <TextContentWrapper>
      <FooterContent>
        Copyright © {new Date().getFullYear()} &middot; KOZO KEIKAKU ENGINEERING Inc. All Rights Reserved.
      </FooterContent>
      <FooterLinks>
        <a href="https://www.kke.co.jp/legal/" target="_blank" rel="noopener noreferrer">ご利用について</a>
        <a href="https://www.kke.co.jp/security_policy/privacy.html" target="_blank" rel="noopener noreferrer">情報セキュリティ・個人情報について</a>
        <a href="https://www.kke.co.jp/aboutus/" target="_blank" rel="noopener noreferrer">会社情報</a>
      </FooterLinks>
    </TextContentWrapper>
  </FooterWrapper>
);

export default Footer;